import { render, staticRenderFns } from "./PathwayCard.vue?vue&type=template&id=18222ab0&scoped=true&"
import script from "./PathwayCard.vue?vue&type=script&lang=js&"
export * from "./PathwayCard.vue?vue&type=script&lang=js&"
import style0 from "./PathwayCard.vue?vue&type=style&index=0&id=18222ab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18222ab0",
  null
  
)

export default component.exports